import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#9B59FF', // Lila intenso más brillante
      dark: '#6f2ddb',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FF5722',
      dark: '#D84315',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#000000', // Fondo general completamente negro
      paper: '#0A0A0A',   // Elementos como Card, Drawer, Dialogs
    },
    text: {
      primary: '#FFFFFF',      // Blanco puro
      secondary: '#B0BEC5',    // Gris claro para subtítulos
    },
    success: {
      main: '#4CAF50',
    },
    error: {
      main: '#F44336',
    },
    divider: 'rgba(255,255,255,0.08)',
  },

  typography: {
    fontFamily: 'Roboto, sans-serif',
    h3: { fontWeight: 700, color: '#ffffff' },
    h6: { fontWeight: 500, color: '#ffffff' },
    body1: { fontWeight: 400, color: '#dddddd' },
    body2: { fontWeight: 400, color: '#aaaaaa' },
  },

  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          backgroundColor: '#0A0A0A',
          boxShadow: '0 10px 30px rgba(255, 255, 255, 0.04)',
          border: '1px solid rgba(255, 255, 255, 0.06)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 10,
          padding: '12px 24px',
          fontWeight: 600,
          fontSize: '0.95rem',
        },
        contained: {
          background: 'linear-gradient(135deg, #9b59ff 0%, #6f2ddb 100%)',
          color: '#ffffff',
          boxShadow: '0 6px 18px rgba(155, 89, 255, 0.35)',
          '&:hover': {
            background: 'linear-gradient(135deg, #6f2ddb 0%, #5b23b1 100%)',
          },
        },
        outlined: {
          borderColor: 'rgba(255, 255, 255, 0.12)',
          color: '#ffffff',
          '&:hover': {
            borderColor: '#9B59FF',
            backgroundColor: 'rgba(155, 89, 255, 0.08)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#000000',
          boxShadow: '0 2px 8px rgba(255, 255, 255, 0.05)',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
        },
      },
    },
  },
});

export default theme;
